import { Img } from '@qonsoll/react-design'
import logoQonsoll from 'assets/logo-ql-full-primary.svg'

const Logo = () => {
  return <Img src={logoQonsoll} alt="Qonsoll" height="40" />
}

export default Logo
